import toast, { ToastOptions } from 'react-hot-toast';
import { createCustomToast } from './CustomToast';

// Интерфейс для совместимости со старым кодом
export interface BasicToastrOptions {
    timeOut?: number;
    showCloseButton?: boolean;
    progressBar?: boolean;
    [key: string]: any;
}

// Объединяет title и message в одну строку
function formatMessage(title: string, message: string): string {
    if (!title?.trim()) return message;
    if (!message?.trim()) return title;
    return `${title}: ${message}`;
}

// Конвертация опций
function convertOptions(options?: BasicToastrOptions): ToastOptions | undefined {
    if (!options) return undefined;
    const toastOptions: ToastOptions = {};
    if (options.timeOut !== undefined) {
        toastOptions.duration = options.timeOut;
    }
    // showCloseButton и progressBar игнорируются (встроены в react-hot-toast)
    return toastOptions;
}

// API совместимый с react-redux-toastr
export const toastr = {
    success: (title: string, message: string, options?: BasicToastrOptions): string => {
        return createCustomToast(title, message, 'success');
    },
    error: (title: string, message: string, options?: BasicToastrOptions): string => {
        return createCustomToast(title, message, 'error');
    },
    warning: (title: string, message: string, options?: BasicToastrOptions): string => {
        return createCustomToast(title, message, 'warning');
    },
    info: (title: string, message: string, options?: BasicToastrOptions): string => {
        return createCustomToast(title, message, 'info');
    },
    remove: (id?: string) => toast.dismiss(id),
    clear: () => toast.dismiss(),
};

export { toast };
